import { render, staticRenderFns } from "./v-handler-ship-code.vue?vue&type=template&id=4c6d8cac&"
import script from "./v-handler-ship-code.vue?vue&type=script&lang=js&"
export * from "./v-handler-ship-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports